import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { IsaAllowance } from '../../../Models/Domains/IsaAllowance/IsaAllowance';

declare var IS_RUNNING_IN_APP_POOL;

export class IsaAllowanceOverviewClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(hierarchyId: string, yearsFromCurrentTaxYear: number): Promise<IsaAllowance, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/ProductOverview/IsaAllowanceOverview/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, yearsFromCurrentTaxYear: yearsFromCurrentTaxYear }

    return AjaxWrapper.get<IsaAllowance, any>(url, data);
  }
}

